import React from 'react';
import PropTypes from 'prop-types';

const SvgBringFront = ({ active, ...props }) => {
    const fillColor = active ? '#128383' : '#ffffff';
    const strokeColor = active ? '#ffffff' : '#343A72';
    const color = active ? '#7AB3B3' : '#9A9DB6';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26" {...props}>
            <path
                fill={color}
                stroke={strokeColor}
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="m15.789 25.2-9.411-4.706 9.41-4.705 9.412 4.705-9.411 4.706Z"
            />
            <path
                fill={fillColor}
                stroke={strokeColor}
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="m15.789 18.478-9.411-4.706 9.41-4.705 9.412 4.705-9.411 4.706Z"
            />
            <path
                fill={strokeColor}
                stroke={strokeColor}
                strokeLinejoin="round"
                d="M8.394 1v6.592L6.6 5.755c-3.88 3.974-4.904 9.368-2.286 12.05-4.19-4.292-4.44-10.99-.56-14.965L1.958 1h6.437Z"
            />
        </svg>
    );
};
SvgBringFront.propTypes = {
    active: PropTypes.bool,
};
SvgBringFront.defaultProps = {
    active: false,
};
export default SvgBringFront;
